import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AdminNav from '../components/AdminNav';
import SuperAdminNav from '../components/SuperAdminNav';
import DashboardView from '../views/DashboardView';
import ApplicationsView from '../views/ApplicationsView';
import SignaturesView from '../views/SignaturesView';
import ImagesView from '../views/ImagesView';
import PropertiesView from '../views/PropertiesView';
import StudentsView from '../views/StudentsView';
import SettingsView from '../views/SettingsView';

const AdminDashboard = () => {
  const location = useLocation();
  const { isSuperAdmin } = useAuth();
  const path = location.pathname.split('/').pop();

  const renderView = () => {
    switch (path) {
      case 'applications':
        return <ApplicationsView />;
      case 'signatures':
        return <SignaturesView />;
      case 'images':
        return <ImagesView />;
      case 'properties':
        return <PropertiesView />;
      case 'students':
        return <StudentsView />;
      case 'settings':
        return <SettingsView />;
      default:
        return <DashboardView />;
    }
  };

  return (
    <div className="flex gap-8">
      {/* Navigation */}
      <div className="w-80 flex-shrink-0">
        {isSuperAdmin() ? <SuperAdminNav /> : <AdminNav />}
      </div>

      {/* Main Content */}
      <div className="flex-1">
        {renderView()}
      </div>
    </div>
  );
};

export default AdminDashboard;